import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import Footer from "../../Footer";
import Header from "../../Header";
import { authServices } from "../../../services"

const PrivateRoute = () => {
  const location = useLocation();
  return (
    authServices.isLoggedIn()
      ? (
        <>
          <Header />
          <Outlet />
          <Footer />
        </>
      )
      : <Navigate to="/auth/login" state={{ from: location.pathname }} />
  );
}

export default PrivateRoute;